// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/77f0f5774e2561c21346.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"2d695ef313cd80a581ed","135":"cc7bba075e5f72bd755b","136":"40484c8d3fa362fae5ef"}[chunkId] + ".chunk.js";
};